import { colorConstants, fontWeightConstants } from 'src/theme/mindly_constants';
import styled from 'styled-components';
import { IonIcon } from '@ionic/react';

export const StyledDeleteIcon = styled(IonIcon)`
  z-index: 1;
  position: relative;
  padding: 0 20px;
  color: #c1c1c1;
  width: 18px;
  height: 24px;
  justify-self: end;

  &:hover {
    color: #8d8d8dff;
  }
`;

export const Wrapper = styled.div`
  margin-inline: auto;
  height: auto;
  /* width: min(100%, 480px); */
  box-sizing: border-box;

  label {
    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const SavedCardInfo = styled.div`
  display: flex;
  align-items: center;
`;

export const Fake = styled.span`
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid ${colorConstants.AccentDisabledColor};
  border-radius: 50%;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: block;
    width: 8px;
    height: 8px;
    background-color: ${colorConstants.primaryColor};
    border-radius: 50%;
    opacity: 0;
    transition: 0.2s;
  }
`;

type PropsType = {
  isActive: boolean;
};

export const Label = styled.label<PropsType>`
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px;
  border: 1px solid
    ${(props) => (props.isActive ? colorConstants.AccentInputBgColor : colorConstants.secondaryTextColor)};
  border-radius: 4px;
  border-color: ${(props) =>
    props.isActive ? colorConstants.AccentDisabledColor : colorConstants.AccentDisabledColor};
  background-color: ${(props) =>
    props.isActive ? colorConstants.AccentBackgroundWhite : colorConstants.AccentBackgroundWhite};
  /* box-shadow: ${(props) => (props.isActive ? '0px 4px 4px rgba(0, 0, 0, 0.25)' : 'none')}; */
  cursor: pointer;
`;

export const Radio = styled.input`
  display: none;

  &:checked + ${Fake} {
    border-color: ${colorConstants.primaryColor};
  }

  &:checked + ${Fake}::before {
    opacity: 1;
  }
`;

export const CardOperatorImageContainer = styled.div`
  margin: 0 14px;
  width: 54px;
  height: 36px;

  img {
    width: 100%;
    height: 100%;
  }
`;

export const CardOperatorAndNumber = styled.div`
  display: flex;
  text-transform: capitalize;

  h4 {
    display: flex;
    align-items: center;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
  }

  h4 span {
    margin-right: 4px;
  }

  h4:first-child {
    margin-right: 8px;
  }
`;

export const CardExpireDate = styled.p`
  font-size: 12px;
  line-height: 14px;
  font-weight: ${fontWeightConstants.regular};
  color: #5b5b5b;
`;
